
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.68 0C8.564 0 .363 8.283.363 18.5c0 10.218 8.2 18.5 18.317 18.5 10.116 0 18.316-8.282 18.316-18.5 0-10.217-8.2-18.5-18.316-18.5zm11.7 24.436a3.079 3.079 0 01-2.16 2.182c-1.904.515-9.54.515-9.54.515s-7.636 0-9.541-.515a3.078 3.078 0 01-2.16-2.182c-.51-1.924-.51-5.936-.51-5.936s0-4.012.51-5.936a3.079 3.079 0 012.16-2.182c1.905-.515 9.54-.515 9.54-.515s7.637 0 9.542.515a3.079 3.079 0 012.16 2.182c.51 1.924.51 5.936.51 5.936s0 4.012-.51 5.936z","fill":"#FEFEFE"}}),_c('path',{attrs:{"d":"M16.238 22.2l6.345-3.7-6.345-3.7v7.4z","fill":"#FEFEFE"}})])
          )
        }
      }
    